import React, {Component} from 'react';
import {bind, defaultIfBlank, pushWithParamsFromProps} from 'utils';
import {connect} from 'react-redux';
import {appSetComputing} from 'store/app/actions';
import {userSetInfo} from 'store/user/actions';
import {dispatch} from 'store';
import APIRequest from 'api/APIRequest';
import TextBox from 'components/general/textBox/TextBox';
import SubmitButton from 'components/general/submitButton/SubmitButton';
import PoweredBy from 'components/general/poweredBy/PoweredBy';
import ArrowRight from 'components/general/svg/ArrowRight';
import  {getLocalizedStrings} from 'locale/i18n';
import Computing from 'components/general/computing/Computing';
import PropTypes from 'prop-types';
import './Phone.scss';

class Phone extends Component {
  constructor (...args) {
    super(...args);
    this.state = {
      phone: '',
      email: '',
      privacy: 0,
      contactMe: 0,
      contactConsentMessage: '',
      messageHtml: '',
      termsLink: '',
      policyLink: '',

      errors: {
        phone: '',
        email: '',
        privacy: '',
        contactMe: ''
      }
    };
    bind(this, [
      'onClick', 'handleChange', 'handleCheckboxChange', 'sendLeads', 'validate', 'validateForm'
    ]);
  }

  componentDidMount() {
    if (!this.props.user.model.companyName) {
      pushWithParamsFromProps(this.props, '/');
    }
    this.setState({
      ...this.props.app.config.privacy
    });
  }

  validate (name, value) {
    const strings = getLocalizedStrings(this.props.app.config.lang);
    // eslint-disable-next-line
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    return new Promise(resolve => {
      let errorVal = '';
      switch (name) {
        case 'phone':
          errorVal =
            value.length < 1
              ? strings['error-val-phone-required'] : '';
          errorVal =
            isNaN(value)
              ? strings['error-val-phone-invalid'] : errorVal;
          break;
        case 'email':
          errorVal =
            validEmailRegex.test(value)
              ? ''
              : strings['error-val-email-not-valid'];
          errorVal =
            value.length === 0
              ? errorVal = strings['error-val-email-required']
              : errorVal;
          break;
        case 'privacy':
          errorVal =
            value === 1
              ? ''
              : strings['error-val-privacy-required'];
          break;
        case 'contactMe':
          errorVal =
            value === 1
              ? ''
              : strings['error-val-contact-me-required'];
          break;
        default:
          break;
      }
      this.setState(state => {
        return {
          errors: {
            ...state.errors,
            [name]: errorVal
          },
          [name]: value
        };
      }, () => resolve());
    });
  }

  async validateForm () {
    let valid = true;
    await this.validate('phone', this.state.phone);
    await this.validate('email', this.state.email);
    await this.validate('privacy', this.state.privacy);
    await this.validate('contactMe', this.state.contactMe);
    Object.values(this.state.errors).forEach(
      (val) => val.length > 0 && (valid = false)
    );
    return valid;
  }

  handleChange (e) {
    const target = e.target;
    const value = target.value.replace(/[- +]/g, '');
    const name = target.name;
    this.validate(name, value);
    this.setState({ [name]: value });
  }

  handleCheckboxChange (name) {
    let value = 0;
    switch (name) {
      case 'privacy':
        if (this.state.privacy === 0) {
          value = 1;
        }
        break;
      case 'contactMe':
        if (this.state.contactMe === 0) {
          value = 1;
        }
        break;
      default:
        break;
    }

    this.validate(name, value, this.state.errors);
    this.setState({ [name]: value });
  }

  async onClick () {
    if (await this.validateForm()) {
      dispatch(appSetComputing(true));
      this.sendLeads();
    }
  }

  async sendLeads () {
    try {
      const data = {
        source: {
          id: this.props.app.config.source.id,
          email: this.props.app.config.source.email,
          notificationEmail: this.props.app.config.source.notificationEmail
        },
        company: {
          businessId: this.props.user.model.companyCode,
          name: this.props.user.model.companyName,
          contact: {
            email: this.state.email,
            phone: this.state.phone,
            lang: this.props.app.config.lang
          }
        }
      };
      this.api = new APIRequest();
      const saved = await this.api.sendLead(data);

      const userInfo = {
        ...this.props.user.info,
        leadId: saved.id,
        phone: this.state.phone,
        email: this.state.email,
        privacy: this.state.privacy,
        contactMe: this.state.contactMe
      };
      dispatch(userSetInfo(userInfo));
      dispatch(appSetComputing(false));
      pushWithParamsFromProps(this.props, '/results');
    } catch (error) {
      const userInfo = {
        ...this.props.user.info,
        error: true
      };
      dispatch(userSetInfo(userInfo));
      dispatch(appSetComputing(false));
      pushWithParamsFromProps(this.props, '/info');
    }
  }

  static get propTypes () {
    return {
      user: PropTypes.object,
      app: PropTypes.object
    };
  }

  render () {
    const strings = getLocalizedStrings(this.props.app.config.lang);
    return (
      <div className='phone-container app-container fade-animation'>
        {this.props.app.computing === true && <Computing loadingStage={2}/>}
        {this.props.app.computing === false &&
          <div className='phone-sub-container'>
            <div>
              <h1 className='page-name'>{strings['phone-title']}</h1>
              <p>{strings['phone-note']}</p>
              <TextBox label={strings['input-phone']} name='phone' type='tel' value={this.state.phone}
                       onHandleChange={this.handleChange} errors={this.state.errors}/>
              <TextBox label={strings['input-email']} name='email' type='email' value={this.state.email}
                       onHandleChange={this.handleChange} errors={this.state.errors}/>
              <SubmitButton label={strings['submit-button']} handleClick={this.onClick}/>
              <div className='terms' onClick={() => {
                this.handleCheckboxChange('privacy');
              }}>
                {this.state.privacy === 1 ? <span className='checked'>✔</span> : <span/>}
                  {this.state.messageHtml ? (
                    <label dangerouslySetInnerHTML={{__html: this.state.messageHtml}}/>
                  ) : (
                    <label>
                      {strings['phone-privacy-text-1']}{' '}
                      <a target="_blank" rel="noopener noreferrer" href={this.state.termsLink}>
                        {strings['phone-privacy-terms']}
                      </a>{' '}
                      {strings['phone-privacy-text-2']}{' '}
                      <a target="_blank" rel="noopener noreferrer" href={this.state.policyLink}>
                        {strings['phone-privacy-policy']}
                      </a>
                    </label>
                  )}
              </div>
              <div className='terms' onClick={() => {
                this.handleCheckboxChange('contactMe');
              }}>
                {this.state.contactMe === 1 ? <span className='checked'>✔</span> : <span/>}
                <label>
                  {defaultIfBlank(this.state.contactConsentMessage, strings['phone-contact-me-text'])}
                </label>
              </div>
              {this.state.errors.privacy.length > 0 &&
                <div className='terms-required'>{this.state.errors.privacy}</div>}
              {this.state.errors.contactMe.length > 0 &&
                <div className='terms-required'>{this.state.errors.contactMe}</div>}
            </div>
            <div className='powered-by-container footer-powered-by'>
              <PoweredBy/>
              <a className='fundu-site' target='_blank' rel='noopener noreferrer' href={strings['fundu-link']}>
                {strings['fundu-site']} <ArrowRight/>
              </a>
            </div>
          </div>}
      </div>
    );
  }

  static getConfigFromParams(params = {}, lang) {
    const strings = getLocalizedStrings(lang);
    return {
      contactConsentMessage: params?.['privacy.contactConsentMessage'],
      messageHtml: defaultIfBlank(params?.['privacy.messageHtml'], null),
      termsLink: defaultIfBlank(params?.['privacy.termsLink'], strings['terms-link']),
      policyLink: defaultIfBlank(params?.['privacy.policyLink'], strings['terms-link'])
    }
  }
}

export default connect(state => ({user: state.user, app: state.app}))(Phone);
